export default {
  TURNSTILE_KEY: '0x4AAAAAAB8d5wIY4nQgyHa1',
};
